module.exports = __webpack_public_path__ + "packs/media/images/Home_Mobile-581aa59548c3f41685008331d75f5551.jpg";